import { render, staticRenderFns } from "./PriceItem.vue?vue&type=template&id=2f016d81&scoped=true"
import script from "./PriceItem.vue?vue&type=script&lang=js"
export * from "./PriceItem.vue?vue&type=script&lang=js"
import style0 from "./PriceItem.vue?vue&type=style&index=0&id=2f016d81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f016d81",
  null
  
)

export default component.exports